module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/allocation/saledeed/sale/sale.component.css
// module id = ./src/app/allocation/saledeed/sale/sale.component.css
// module chunks = main